import styled from '@emotion/styled';

export const SadaEmployee = styled.div``;
